import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { RouterPath } from '../router-path';
import { DynamicRouterPath } from '../dynamic-router-path';
export var BaseAppRouter = /*#__PURE__*/function () {
  function BaseAppRouter(appId, path) {
    _classCallCheck(this, BaseAppRouter);

    _defineProperty(this, "_appId", void 0);

    _defineProperty(this, "_vercelDomain", void 0);

    _defineProperty(this, "_path", void 0);

    this._appId = appId;
    this._path = path;
  }

  _createClass(BaseAppRouter, [{
    key: "appId",
    get: function get() {
      return this._appId;
    }
  }, {
    key: "vercelDomain",
    get: function get() {
      return this._vercelDomain;
    }
  }, {
    key: "updateVercelDomain",
    value: function updateVercelDomain(vercelDomain) {
      this._vercelDomain = vercelDomain;
    }
  }, {
    key: "absolutePath",
    get: function get() {
      return this._path;
    }
  }, {
    key: "fullPath",
    get: function get() {
      var _this = this;

      var processPath = function processPath(path) {
        if (path instanceof DynamicRouterPath) {
          return DynamicRouterPath.createWithDynamic(function () {
            return RouterPath.create("".concat(_this.vercelDomain).concat(path.pathParams.apply(path, arguments).path));
          }, path.path);
        }

        if (path instanceof RouterPath) {
          return RouterPath.create("".concat(_this.vercelDomain).concat(path.path));
        }

        if (typeof path === 'object' && path !== null) {
          var newObj = {};
          Object.entries(path).forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];

            newObj[key] = processPath(value);
          });
          return newObj;
        }

        return path;
      };

      return processPath(this._path);
    }
  }, {
    key: "convertPatternToRegex",
    value: function convertPatternToRegex(pattern) {
      // Escape special regex characters except [ and ]
      var escaped = pattern.replace(/[.*+?^${}()|]/g, '\\$&'); // Replace [paramName] with named capture groups

      var regexPattern = escaped.replace(/\[([^\]]+)\]/g, '([^/]+)');
      return new RegExp("^".concat(regexPattern, "$"));
    }
  }, {
    key: "isPathProtected",
    value: function isPathProtected(obj, inputPath) {
      for (var _i = 0, _Object$entries = Object.entries(obj); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            _key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        if (value instanceof DynamicRouterPath) {
          var regex = this.convertPatternToRegex(value.path); // Check if the input path matches the regex

          if (regex.test(inputPath)) {
            return value.isProtected;
          }
        }

        if (value instanceof RouterPath && value.path === inputPath) {
          return value.isProtected;
        }

        if (typeof value === 'object' && value !== null && !('path' in value)) {
          var result = this.isPathProtected(value, inputPath);

          if (result !== undefined) {
            return result;
          }
        }
      }

      return undefined;
    }
  }, {
    key: "checkProtectedPath",
    value: function checkProtectedPath(path) {
      var result = this.isPathProtected(this._path, path);
      return result !== null && result !== void 0 ? result : false;
    }
  }], [{
    key: "register",
    value: function register(config) {
      var appRouterInstance = new this();
      var isOnLocalhost = !config.branchName || config.environment === 'local';

      if (isOnLocalhost) {
        appRouterInstance.updateVercelDomain(config.baseUrl);
      } else {
        var isNotProduction = config.environment !== 'production';
        var isNotMainBranch = config.branchName !== 'main';

        if (isNotProduction && isNotMainBranch) {
          appRouterInstance.updateVercelDomain("https://".concat(appRouterInstance.appId, "-git-").concat(config.branchName.toLowerCase(), "-digibricks.vercel.app"));
        } else {
          appRouterInstance.updateVercelDomain(config.baseUrl);
        }
      }

      return appRouterInstance;
    }
  }]);

  return BaseAppRouter;
}();